export const environment = {
  REACT_APP_Services_URL: "https://api.wajeez.com",
};
